import { XcentiumAccountSettingsActions } from "@electricMotorShop/Store/Data/AccountSettings/AccountSettingsReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { DispatchProp } from "react-redux";

// XC Customization - Adding validation for new fields and calling the new AccountSetting reducer

type CustomProps = DispatchProp<XcentiumAccountSettingsActions>

type HandlerType = Handler<
    {
        isSubscribed?: boolean;
        billToId?: string;
        shipToId?: string;
        useDefaultCustomer?: boolean;
        email?: string;
        fulfillmentMethod?: string;
        defaultWarehouse?: WarehouseModel;
        firstName?:string;
        lastName?:string;
    },
    {
        emailErrorMessage?: string;
        firstNameErrorMessage?: string;
        lastNameErrorMessage?: string;
    }
>;

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

export const ValidateEmail: HandlerType = props => {
    const {
        parameter: { email },
    } = props;
    if (typeof email === "undefined") {
        return;
    }

    const requiredFieldMessage = siteMessage("Field_Required", translate("Email Address"));
    const emailFieldMessage = siteMessage("Field_Invalid", translate("Email Address"));
    const errorMessage = email === "" ? requiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
    props.emailErrorMessage = errorMessage as string;
};

export const ValidateFirstName: HandlerType = props => {
    const {
        parameter: { firstName },
    } = props;
    if (typeof firstName === "undefined") {
        return;
    }

    const firstNameRequiredFieldMessage = siteMessage("Field_Required", translate("First Name"));
    const errorMessage = firstName === "" ? firstNameRequiredFieldMessage : "";
    props.firstNameErrorMessage = errorMessage as string;
};

export const ValidateLastName: HandlerType = props => {
    const {
        parameter: { lastName },
    } = props;
    if (typeof lastName === "undefined") {
        return;
    }

    const lastNameRequiredFieldMessage = siteMessage("Field_Required", translate("Last Name"));
    const errorMessage = lastName === "" ? lastNameRequiredFieldMessage : "";
    props.lastNameErrorMessage = errorMessage as string;
};



export const DispatchUpdateAccountSettings: HandlerType = props => {
    
    const customProps = props as CustomProps;
    customProps.dispatch({
        ...props.parameter,
        emailErrorMessage: props.emailErrorMessage,
        firstNameErrorMessage: props.firstNameErrorMessage,
        lastNameErrorMessage: props.lastNameErrorMessage,
        type: "Custom/AccountSettings/UpdateAccountSettings",
    });
};

export const chain = [ValidateEmail, ValidateFirstName,ValidateLastName, DispatchUpdateAccountSettings];

const updateAccountSettings = createHandlerChainRunner(chain, "UpdateAccountSettings");
export default updateAccountSettings;
